import React from 'react';
import { connect } from 'react-redux';
import { hideNotification } from '../../store/actions/notification';
import DashboardLayout from './../layout/Dashboard';
import { FormattedMessage } from 'react-intl';
import { Messages } from "../../components/layout/Messages/Messages";
import { NOTIFICATION_CAMPAIGN_ACTIONS } from '../../config/notifications';
import { ACL } from '../../config/constants';
import { NoRights } from '../../components/layout/Permissions/NoRights';
import { CreateCampaignForm } from "../../components/pages/campaignManagement/createCampaign/CreateCampaignForm";
import {
  PageHeader,
  PageSurface,
  PageWorkspace
} from '../../components/layout/Workspace';
import './CreateCampaign.scss';

function CreateCampaignComponent(props) {
  return (
    <DashboardLayout
      pageTitle={<FormattedMessage id="app.dashboard.page_title"/>}
      workspace
      {...props}
    >
      <PageWorkspace className="create-campaign-workspace">
        <PageHeader title={<FormattedMessage id="components.pages.campaignManagement.create.title"/>}/>
        <div className="create-campaign-notifications">
          <Messages/>
          <Messages notificationId={ NOTIFICATION_CAMPAIGN_ACTIONS } />
        </div>
        <PageSurface className="create-campaign-surface">
          { ACL.CLIENT.CAMPAIGNS.CREATE.hasAccess() ? <CreateCampaignForm/> : <NoRights/> }
        </PageSurface>
      </PageWorkspace>
    </DashboardLayout>
  );
}

const mapActionsToProps = { hideNotification };

const CreateCampaign = connect(null, mapActionsToProps)(CreateCampaignComponent);

export { CreateCampaign, CreateCampaignComponent };
